import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user.icon",
  "use": "user.icon-usage",
  "viewBox": "5125.727 -7730.834 18.082 21.549",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"5125.727 -7730.834 18.082 21.549\" id=\"user.icon\"><defs><style>#user.icon .cls-1{fill:#46ccd5}</style></defs><g id=\"user.icon_Group_1028\" data-name=\"Group 1028\" transform=\"translate(4121.191 -8029.389)\"><ellipse id=\"user.icon_Ellipse_60\" data-name=\"Ellipse 60\" class=\"cls-1\" cx=\"5.805\" cy=\"5.805\" rx=\"5.805\" ry=\"5.805\" transform=\"translate(1007.771 298.555)\" /><path id=\"user.icon_Path_264\" data-name=\"Path 264\" class=\"cls-1\" d=\"M245.3,146.741a9.041,9.041,0,0,1,18.082,0\" transform=\"translate(759.235 173.363)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user.icon.svg
// module id = oHyk
// module chunks = 13